import { environment } from '../../environments'

/**
 * Ref: https://my.goto.cloud/catalog/default/api/gtc-bff/definition#/Organization/get_organizations__organizationId__
 */
export const getGtcBffOrganizationInformationUrl = (organizationId: string): string =>
  `${environment().gtcBffServiceBaseUrl()}/organizations/${organizationId}`
